<script>
import { authComputed } from '@state/helpers'

export default {
  data() {
    return {
      items: [
        {
          title: 'Dashboard',
          src: '/assets/icon-dashboard.svg',
          alt: 'dashboard',
          route: 'home',
        },
        {
          title: 'CDM',
          src: '/assets/icon-cdm.png',
          alt: 'cdm',
          route: 'cdms',
        },
        {
          title: 'Requests',
          src: '/assets/icon-requests.svg',
          alt: 'requests',
          route: 'cdmrs',
          query: { type: 'inbox' },
        },
        {
          title: 'Reports',
          src: '/assets/icon-reports.svg',
          alt: 'reports',
          route: 'reports',
        },
        {
          title: 'Settings',
          src: '/assets/icon-settings.svg',
          alt: 'settings',
          route: 'settings',
        },
        {
          title: 'C3',
          src: '/assets/icon-c3.svg',
          alt: 'c3',
          route: 'c3',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
}
</script>

<template>
  <v-navigation-drawer
    permanent
    fixed
    width="80"
    height="100vh"
    class="sideNav"
  >
    <v-toolbar color="white" flat>
      <v-list>
        <v-list-tile>
          <router-link :to="{ name: 'home' }">
            <img
              src="@assets/images/logo_black.png"
              alt="BV"
              width="100%"
              height="100%"
            />
          </router-link>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-list class="mt-4">
      <v-list-tile
        v-for="item in items"
        :key="item.title"
        :to="{ name: item.route, query: item.query }"
      >
        <v-layout column align-center>
          <!-- <v-icon>{{ item.icon }}</v-icon> -->
          <img :src="item.src" :alt="item.alt" />

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-layout>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<style lang="scss">
@import '@design';

.sideNav {
  box-shadow: 0 0 20px 0 rgba(58, 75, 207, 0.14);
}
</style>
